import React, { PropsWithChildren } from 'react';

import { TextWithHighlightContainer } from './textWithHighlight.styled';

export function TextWithHighlight({ children }: PropsWithChildren) {
  return <TextWithHighlightContainer>{children}</TextWithHighlightContainer>;
}
